import { Component } from '@angular/core';

@Component({
  selector: 'app-sidepanel-footer',
  imports: [],
  template: `<ng-content />`,
  host: {
    class: 'p-md border-stroke-neutral-light border-t',
  },
})
export class SidepanelFooterComponent {}
